import { render } from "./CinemasEditGallery.vue?vue&type=template&id=c6614768&scoped=true"
import script from "./CinemasEditGallery.vue?vue&type=script&lang=js"
export * from "./CinemasEditGallery.vue?vue&type=script&lang=js"

import "./CinemasEditGallery.vue?vue&type=style&index=0&id=c6614768&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6614768"]])

export default __exports__